module.exports = __webpack_public_path__ + "static/media/zeus.9acc0674.png";